const storageKey = (key: string) => `@AvicolaPB:${key}`;

export default storageKey;
